import * as icons from '@mui/icons-material';

const getIcon = (name, className) => {
  const Icon = icons[name];
  return <Icon className={className ? className : null} />;
};

export default getIcon;
